// @flow
import React from 'react';
import HorizontalOrderBook from './HorizontalOrderBook';
import VerticalOrderBook from './VerticalOrderBook'
import { AutoSizer } from 'react-virtualized'
import type { TokenPair } from '../../types/tokens';
import type { DisplayMode } from '../../types/account'


type BidOrAsk = {
  price: number,
  amount: number,
  total: number,
};

type Props = {
  loading: boolean,
  asks: Array<BidOrAsk>,
  bids: Array<BidOrAsk>,
  currentPair: TokenPair,
  midMarketPrice: ?number,
  spread: ?number,
  displayMode: DisplayMode,
  select: BidOrAsk => void,
  onCollapse: string => void,
  onExpand: string => void,
  onResetDefaultLayout: void => void
};

type State = {
  selectedTabId: string,
  isOpen: boolean,
  directionSetting: "vertical" | "horizontal"
};

class OrderBook extends React.Component<Props, State> {
  state = {
    isOpen: true,
    selectedTabId: 'list',
    directionSetting: 'horizontal'
  };

  changeTab = (tabId: string) => {
    this.setState({ selectedTabId: tabId });
  };

  toggleCollapse = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    this.props.onCollapse('orderBook')
  };

  expand = () => {
    this.props.onExpand('orderBook')
  }

  renderOrderBook = (width: number, height: number) => {
    const {
      props: { 
        bids, 
        asks,
        currentPair,
        midMarketPrice,
        spread,
        select,
        onResetDefaultLayout,
        displayMode
      },
      state: { 
        selectedTabId, 
        isOpen, 
        directionSetting
      },
      changeTab,
      toggleCollapse,
      expand,
    } = this

    const direction = (width < 500) ? "vertical" : directionSetting

    return {
      "vertical": 
        <VerticalOrderBook 
          bids={bids}
          asks={asks}
          currentPair={currentPair}
          midMarketPrice={midMarketPrice}
          spread={spread}
          onSelect={select}
          selectedTabId={selectedTabId}
          isOpen={isOpen}
          changeTab={changeTab}
          toggleCollapse={toggleCollapse}
          expand={expand}
          onResetDefaultLayout={onResetDefaultLayout}
          displayMode={displayMode}
        />,
      "horizontal": 
        <HorizontalOrderBook 
          bids={bids}
          asks={asks}
          currentPair={currentPair}
          midMarketPrice={midMarketPrice}
          spread={spread}
          onSelect={select}
          selectedTabId={selectedTabId}
          isOpen={isOpen}
          changeTab={changeTab}
          toggleCollapse={toggleCollapse}
          expand={expand}
          onResetDefaultLayout={onResetDefaultLayout}
          displayMode={displayMode}
        />
    }[direction]
  }

  render() {
    return (
      <AutoSizer style={{ width: '100%', height: '100%' }}>
        {({ width, height }) => {
           return this.renderOrderBook(width, height)
        }}
      </AutoSizer>
    )    
  }
}

export default OrderBook;



// WEBPACK FOOTER //
// ./src/components/OrderBook/OrderBook.js